import React from "react";
import styled from "styled-components";
import Accordion from "../../common/accordion/Accordion";
import VideoHotKeys from "../common/VideoHotKeys";
import AuditCalAdjustmentHotKeys from "./AuditCalAdjustmentHotKeys";
import AuditMiscHotKeys from "../common/AuditMiscHotKeys";

const Body = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
`;

class AuditCameraCalHotKeys extends React.Component {
  render() {
    return (
      <div className="mt-1">
        <Accordion title="Hot Keys" padding={false}>
          <Body>
            <div className="row">
              <div className="col-4">
                <VideoHotKeys />
              </div>
              <div className="col-4">
                <AuditCalAdjustmentHotKeys />
              </div>
              <div className="col-4">
                <AuditMiscHotKeys />
              </div>
            </div>
          </Body>
        </Accordion>
      </div>
    );
  }
}

export default AuditCameraCalHotKeys;
